export enum SurveyActions {
    SetSurveyButton = '@survey/actions/initialize/survey/common/button',
    SetCommonSurvey = '@survey/actions/initialize/survey/common',
    SetContextSurvey = '@survey/actions/initialize/survey/context',
    Finalization = '@survey/actions/finalization',

    Loading = '@survey/actions/loading',

    Start = '@survey/actions/popup/open',
    ClosePopup = '@survey/actions/popup/close',
}
